import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  UpdateTaskManagerSectionDocument,
  type UpdateTaskManagerSectionMutationVariables,
} from '@/graphql/generated/graphql';

export type UpdateTaskManagerSectionVariables = UpdateTaskManagerSectionMutationVariables;

export const useUpdateTaskManagerSection = () => {
  const mutation = useMutation({
    mutationKey: ['update-task-manager-section'],
    mutationFn: (variables: UpdateTaskManagerSectionMutationVariables) =>
      graphqlClient.request(UpdateTaskManagerSectionDocument, variables),
  });

  return {
    ...mutation,
    updateTaskManagerSection: mutation.mutate,
    updateTaskManagerSectionAsync: mutation.mutateAsync,
  };
};

export const UPDATE_TASK_MANAGER_SECTION_MUTATION = UpdateTaskManagerSectionDocument;
